import axios from "axios";
import { url } from "../constants/api";

const api = axios.create({
    baseURL: url
});

api.interceptors.request.use(async (config: any) => {
    try {

        if (config.params) {
            // Criar um novo objeto para os parâmetros modificados
            let newParams: any = {};
    
            // Iterar sobre todos os parâmetros e remover os colchetes
            for (let key of Object.keys(config.params)) {
                // Criar uma nova chave removendo os colchetes '[]'
                let newKey = key.replace(/\[\]$/, ''); // Remove '[]' do final da chave
                newParams[newKey] = config.params[key];
            }
    
            // Definir os novos parâmetros na configuração
            config.params = newParams;
        }

        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config;
    } catch (err) {
        // console.log(err);
    }
});

api.interceptors.response.use(function (response) {
    // Qualquer código de status que dentro do limite de 2xx faz com que está função seja acionada
    // Faz alguma coisa com os dados de resposta
    return response;
}, function (error) {
    // Qualquer código de status que não esteja no limite do código 2xx faz com que está função seja acionada
    // Faz alguma coisa com o erro da resposta

    if (error.response.status === 401) {
        if(error.response.data.message !== 'Usuário e/ou senha incorretos' && error.response.data.message !== 'Usuário desativado')
        window.location.href = '/';
    }

    return Promise.reject(error);
});


export { api, url };
